import { Box, Grid, IconButton, Tooltip } from '@mui/material'
import React from 'react'
import BannerImage from "assets/backrr_startup_banner.webp"
import { useTheme } from '@emotion/react'
import Cookies from 'js-cookie'
import { Logout } from '@mui/icons-material'
import { RESET_STATE } from 'store/actions'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { checkForAuthorization } from 'utilities/index'
import Footer from 'layout/Footer/Footer'

const OnboardingLayout = ({ children }) => {
    const theme = useTheme()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const currentIP = window.location.host;
    // const handleLogOut = () => {
    //     dispatch({ type: RESET_STATE });
    //     Cookies.remove('X-ST-JWT', { path: '/' });
    //     Cookies.remove('X-ST-JWT', { domain: checkForDomain() });
    //     Cookies.remove('X-ST-ID', { path: '/' });
    //     Cookies.remove('X-ST-ID', { domain: checkForDomain() });
    //     Cookies.remove('name', { path: '/' });
    //     Cookies.remove('user_id', { path: '/' });
    //     Cookies.remove('startup_id', { path: '/' });
    //     Cookies.remove('email', { path: '/' });
    //     Cookies.remove('is_profile_complete', { path: '/' });
    //     Cookies.remove('startup_id', { path: '/' });
    //     Cookies.remove('step', { path: '/' });
    //     Cookies.remove('permissions', { path: '/' });
    //     Cookies.remove('ur', { path: '/' });
    //     Cookies.remove('search_startups', { path: '/' });
    //     Cookies.remove('search_backrr_startups', { path: '/' });
    //     Cookies.remove('backrr_startups_query', { path: '/' });
    //     Cookies.remove('backrr_startups_status', { path: '/' });
    //     const cookies = document.cookie.split(";");
    //     cookies.forEach(cookie => {
    //         const eqPos = cookie.indexOf("=");
    //         const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    //         document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    //     });
    //     navigate('/login');
    // };
    return (
        <Grid xs={12} container sx={{ display: 'flex', justifyContent: 'center', alignItems: "center", minHeight: "100dvh" }}>
            <Box className="container" sx={{ padding: { xs: "0 !important", md: "1rem !important", lg: "1rem !important" }, maxHeight: { xs: "100%", md: 600, lg: 730 } }}>
                <div class="form-section">
                    {children}
                </div>
                <Grid
                    item xs={12} md={6}
                    sx={{ display: 'flex', justifyContent: 'center' }}
                    className='illustration-section'
                >
                    <img
                        src={BannerImage}
                        alt="Illustration"
                    />
                </Grid>
            </Box>
            {!checkForAuthorization() && <Footer />}
        </Grid>
    )
}

export default OnboardingLayout